import { ProfileTemplate } from "./profileTemplate.model";

export const EmployeeTemplate: ProfileTemplate = {
  id: "employee",
  name: "Employee",
  version: 1,
  status: "active",

  steps: [
    {
      id: 1,
      label: "Personal Details",
      scope: "public",
      fields: [
        {
          key: "dob",
          label: "Date of Birth",
          helper: "yyyy-mm-dd",
          type: "date",
          required: true,
        },
        {
          key: "nationality",
          label: "Country of Residence",
          type: "select",
          required: true,
          options: ["Canada", "Ireland", "United States", "United Kingdom", "France"],
        },
        {
          key: "visaStatus",
          label: "Visa Status",
          type: "select",
          required: true,
          options: ["Canadian Citizen", "Permanent Resident", "Work Permit"],
        },
        {
          key: "sin",
          label: "Social Insurance Number",
          helper: "9 digits",
          type: "text",
          required: true,
        },
        {
          key: "permitIssued",
          label: "Work Permit Issued Date",
          type: "date",
          required: true,
        },
        {
          key: "permitExpiry",
          label: "Work Permit Expiry Date",
          type: "date",
          required: true,
        },
      ],
    },
    {
      id: 2,
      label: "Address & Emergency",
      scope: "public",
      fields: [
        { key: "street", label: "Street Address", type: "text", required: true },
        { key: "city", label: "City", type: "text", required: true },
        { key: "province", label: "Province / State", type: "text", required: true },
        { key: "postal", label: "Postal Code", type: "text", required: true },
        { key: "emergencyName", label: "Contact Name", type: "text", required: true },
        { key: "emergencyRelationship", label: "Relationship", type: "text", required: true },
        { key: "emergencyPhone", label: "Phone Number", type: "text", required: true },
        { key: "emergencyEmail", label: "Email Address", type: "text", required: true },
      ],
    },
    {
      id: 3,
      label: "Banking",
      scope: "public",
      fields: [
        { key: "accountHolder", label: "Account Holder Name", type: "text", required: true },
        { key: "transit", label: "Transit Number", type: "text", required: true },
        {
          key: "institution",
          label: "Institution Number",
          type: "select",
          required: true,
          options: ["001","002","003","004","006","010","016","030","039","623","815"],
        },
        { key: "account", label: "Account Number", type: "text", required: true },
      ],
    },
    {
      id: 4,
      label: "Certifications & Medical",
      scope: "public",
      fields: [
        { key: "smartServe", label: "Smart Serve Number", type: "text", required: true },
        { key: "whmis", label: "WHMIS Number", type: "text", required: true },
        { key: "conditions", label: "Medical Notes", type: "textarea", required: true },
      ],
    },
    {
      id: 5,
      label: "Declaration",
      scope: "public",
      fields: [
        { key: "accuracy", label: "Accuracy of Information", type: "checkbox", required: true },
        { key: "updateObligation", label: "Ongoing Obligation to Update", type: "checkbox", required: true },
        { key: "internalUse", label: "Internal Use Acknowledgement", type: "checkbox", required: true },
        { key: "falseInfo", label: "Consequences of False Information", type: "checkbox", required: true },
        { key: "signature", label: "Typed Signature", type: "certification", required: true },
      ],
    },
  ],
};
